import {Injectable} from "@angular/core";
import {CanvasComponent} from "../canvas/canvas.component";
import {DisplacedElementCanvasRenderer} from "./displacedElementIssue.stateinfo";
import {HighlightedElementCanvasRenderer} from "./highlightedElement.stateinfo";
import {PointTextCanvasRenderer} from "@webmate-web-core/shared/components/state/pointText.stateinfo";

export type InfoItemType = string;

export interface StateInfoItem {
  type: InfoItemType
}

export interface CanvasRenderer {
  renderToCanvas(infoItem: StateInfoItem, canvas: CanvasComponent);
}

/**
 * Creates renderers for issues for different purposes
 */
@Injectable({
    providedIn: 'root'
})
export class StateInfoItemRendererFactory {

  private rendererProviders = {
      'IncorrectDimension': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'IncorrectDimensions': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'IncorrectPosition': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'AdditionalElement': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'MissingElement': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'HighlightElement': {
          'canvas': () => new HighlightedElementCanvasRenderer()
      },
      'PointText': {
          'canvas': () => new PointTextCanvasRenderer()
      },
      'PropertyMismatch': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'LayoutComparison.IncorrectDimension': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'LayoutComparison.IncorrectDimensions': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'LayoutComparison.IncorrectPosition': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'LayoutComparison.AdditionalElement': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'LayoutComparison.MissingElement': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      },
      'LayoutComparison.HighlightElement': {
          'canvas': () => new HighlightedElementCanvasRenderer()
      },
      'LayoutComparison.PropertyMismatch': {
          'canvas': () => new DisplacedElementCanvasRenderer()
      }
  };

  makeCanvasRenderer(infoItemType: InfoItemType): CanvasRenderer {
    return this.rendererProviders[infoItemType]['canvas']();
  }

}
